import React from "react";
import { FiAlertTriangle } from "react-icons/fi";
import { Link } from "react-router-dom";
import Header from "../components/Header";

export default function NotFoundPage() {
  return (
    <div className="container ht d-flex justify-content-center align-items-center flex-column text-white text-center mt-5">
      <Header />
      <FiAlertTriangle size={100} color="#fff" />
      <h1>Page Not Found</h1>
      <p className="lead">Oops! The page you're looking for doesn't exist.</p>
      <p>
        Go back to the{" "}
        <Link to="/" className="text-decoration-underline">
          Homepage
        </Link>
        .
      </p>
    </div>
  );
}
